import DigInSummaryItem from './DigInSummaryItem';
export default DigInSummaryItem;
